/**
 * Maintained by Sandon.
 */
import response from '../response'
import SparkMD5 from 'spark-md5'
import cloneDeep from 'lodash-es/cloneDeep'
const cached = {
  // 'type__url__paramStrHash': {
  //   promise: Promise,
  //   lastTime: Number
  // }
}
const Vue = window.fe.vue
const vm = new Vue()

/**
 * @param api: API {type: '', url: ''}
 * @param param: 请求参数
 * @param force: 是否强制请求
 * @param options: 请求时的配置
 * @param headers: 请求时的headers
 * @param timeInterval: 多次请求时间间隔
 * @returns Promise 此promise返回response
 */
export default function cachedRequest (api, param = {}, force = false, options, headers, timeInterval = 1000) {
  const key = `${api.type}__${api.url}___${SparkMD5.hash(JSON.stringify(param))}`
  !cached[key] && (cached[key] = {promise: null, lastTime: 0})
  const nowTime = (new Date()).getTime()
  if (force || !cached[key].promise || nowTime - cached[key].lastTime > timeInterval) {
    cached[key].promise = new Promise(async (resolve, reject) => {
      const res = await response(vm.$noCacheHttp(api.type, api.url, param, headers), {
        loadingOptions: false,
        ...options
      })
      if (res.isOk) {
        return resolve(cloneDeep(res))
      }
      reject(new Error('cachedRequest 请求失败'))
    })
    cached[key].lastTime = nowTime
  }
  return cached[key].promise
}
